import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import chevronBottom from '../../../../../assets/images/icons/arrow/chevron-bottom.svg';
import chevronTop from '../../../../../assets/images/icons/arrow/chevron-top-black.svg';
import checked from '../../../../../assets/images/icons/checked/checked-black.svg';

export const useStyles = makeStyles(({ palette, fontWeights }: Theme) => ({
  select: {
    marginBottom: '1rem',
    '& .MuiInputBase-root': {
      marginTop: 0,
    },
    '& .MuiInputBase-root::before, & .MuiInputBase-root::after': {
      display: 'none',
    },
    '& .MuiSelect-select': {
      width: 'fit-content',
      minHeight: 'unset',
      padding: '0.625rem 2.5rem 0.625rem 0.75rem',
      border: `1px solid ${palette.grey['500']}`,
      borderRadius: '0.5rem',
      color: palette.grey['700'],
      fontWeight: fontWeights.regular,
      background: `no-repeat url(${chevronBottom})`,
      backgroundPosition: 'right 0.75rem center',
      fontSize: '0.875rem',
      lineHeight: 1.4,
    },
    '& .MuiSelect-select[aria-expanded="true"]': {
      backgroundImage: `url(${chevronTop})`,
    },
    '&& .MuiSelect-select': {
      paddingRight: '2.5rem',
    },
    '& svg': {
      display: 'none',
    },
  },
  selectMenuItem: {
    '&.Mui-selected, &.Mui-selected:hover': {
      background: `${palette.secondary.light} no-repeat url(${checked})`,
      backgroundPosition: 'right 0.75rem center',
      backgroundSize: '0.75rem',
    },
  },
}));
